import React from 'react'
import PropTypes from 'prop-types'
import BrandLogo from '../../components/Brand/BrandLogo'
import ThemeToggle from '../../components/Theme/ThemeToggle'
import { brand } from '../../config/settings/brand'
import routes from '../../config/settings/routes'
import {
  BrandLink,
  BrandName,
  NavLink,
  HeaderActions,
  FooterBrand,
  FooterBrandRow,
  FooterText,
  FooterLinks,
} from '../Landing/Landing.styles'

export const MarketingHeader = ({ onLoginClick }) => (
  <>
    <BrandLink to={routes.root} aria-label={`${brand.name} inicio`}>
      <BrandLogo size={28} />
      <BrandName>{brand.name}</BrandName>
    </BrandLink>
    <HeaderActions>
      <ThemeToggle />
      <NavLink to={routes.login} onClick={onLoginClick}>
        Ingresar
      </NavLink>
    </HeaderActions>
  </>
)

MarketingHeader.propTypes = {
  onLoginClick: PropTypes.func,
}

export const MarketingFooter = ({ onLoginClick }) => (
  <>
    <FooterBrand>
      <FooterBrandRow>
        <BrandLink to={routes.root} aria-label={`${brand.name} inicio`}>
          <BrandLogo size={24} />
          <BrandName>{brand.name}</BrandName>
        </BrandLink>
      </FooterBrandRow>
      <FooterText>
        Seguimiento claro de pensión alimenticia en Chile. No constituye
        asesoría legal.
      </FooterText>
    </FooterBrand>
    <FooterLinks as="nav" aria-label="Páginas públicas">
      <NavLink to={routes.root}>Inicio</NavLink>
      <NavLink to={routes.login} onClick={onLoginClick}>
        Ingresar
      </NavLink>
      <NavLink to={routes.privacy}>Privacidad</NavLink>
      <NavLink to={routes.terms}>Términos</NavLink>
    </FooterLinks>
  </>
)

MarketingFooter.propTypes = {
  onLoginClick: PropTypes.func,
}
